import { _ as i } from "./index742.mjs";
import "./index789.mjs";
import { p as o } from "./index788.mjs";
import { __exports as a } from "./index790.mjs";
var p = i, m = a, s = o.CONSTRUCTOR;
p({ target: "Promise", stat: !0, forced: s }, {
  reject: function(t) {
    var r = m.f(this), e = r.reject;
    return e(t), r.promise;
  }
});
